import { useState } from 'react'

const AVAILABLE_SUBORDERS_PAGE_SIZE = 4

export const useDirectContactFormOrderPagination = (
  subject: string,
): {
  currentVisibleCount: number
  onLoadMore: () => void
} => {
  const [pagination, setPagination] = useState({
    subject,
    visibleSubOrderCount: AVAILABLE_SUBORDERS_PAGE_SIZE,
  })
  const isCurrentSubject = pagination.subject === subject
  const currentVisibleCount = isCurrentSubject
    ? pagination.visibleSubOrderCount
    : AVAILABLE_SUBORDERS_PAGE_SIZE

  return {
    currentVisibleCount,
    onLoadMore: (): void => {
      setPagination({
        subject,
        visibleSubOrderCount:
          currentVisibleCount + AVAILABLE_SUBORDERS_PAGE_SIZE,
      })
    },
  }
}
